module.exports = __webpack_public_path__ + "img/calcettoWhite.41f4358f.svg";